package com.far.suller.sections

import androidx.compose.runtime.*
import com.far.suller.components.TestimonialCardV2
import com.far.suller.models.Section
import com.far.suller.models.Testimonial
import com.far.suller.models.Theme
import com.far.suller.util.Constants
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.animation.*
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val AMBER_500 = Color.rgb(245, 158, 11)

val TestimonialMarqueeLeft = Keyframes {
    0.percent { Modifier.translateX(0.percent) }
    100.percent { Modifier.styleModifier { property("transform", "translateX(-33.333%)") } }
}

val TestimonialMarqueeRight = Keyframes {
    0.percent { Modifier.translateX(-33.333.percent) }
    100.percent { Modifier.styleModifier { property("transform", "translateX(0.percent)") } }
}

@Composable
fun testimonialSection() {
    val breakpoint = rememberBreakpoint()
    val isDesktop = breakpoint >= Breakpoint.MD

    Column(
        modifier = Modifier
            .id(Section.Testimonial.id)
            .fillMaxWidth()
            .padding(topBottom = if (isDesktop) 150.px else 80.px)
            .backgroundColor(Theme.Background.rgb)
            .styleModifier {
                property("background-image", "radial-gradient(circle at 2px 2px, rgba(255,255,255,0.01) 1px, transparent 0)")
                property("background-size", "40px 40px")
            },
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        // Inspiration-style Header
        Column(
            modifier = Modifier.margin(bottom = 60.px),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            // Pill tag
            Box(
                modifier = Modifier
                    .margin(bottom = 24.px)
                    .backgroundColor(Color.rgba(255, 255, 255, 0.05f))
                    .padding(leftRight = 20.px, topBottom = 8.px)
                    .borderRadius(50.px)
                    .border(1.px, LineStyle.Solid, Color.rgba(255, 255, 255, 0.1f)),
            ) {
                Span(
                    attrs = Modifier
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(14.px)
                        .fontWeight(FontWeight.Bold)
                        .color(AMBER_500)
                        .toAttrs(),
                ) {
                    Text("Testimonials")
                }
            }

            P(
                attrs = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(if (isDesktop) 64.px else 36.px)
                    .fontWeight(FontWeight.Black)
                    .color(Colors.White)
                    .margin(topBottom = 0.px)
                    .textAlign(TextAlign.Center)
                    .styleModifier {
                        property("letter-spacing", "-2px")
                    }
                    .toAttrs(),
            ) {
                Text("Trusted by leaders")
            }

            P(
                attrs = Modifier
                    .margin(top = 16.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(18.px)
                    .color(Color.rgba(255, 255, 255, 0.5f))
                    .textAlign(TextAlign.Center)
                    .toAttrs(),
            ) {
                Text("Professional recommendations from across various industries.")
            }
        }

        // Dual Marquee "Wall of Recommendations"
        Column(
            modifier = Modifier.fillMaxWidth().overflow(Overflow.Hidden),
        ) {
            // Row 1: Scrolling Left
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(topBottom = 20.px),
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .animation(
                            TestimonialMarqueeLeft.toAnimation(
                                duration = 80.s,
                                timingFunction = AnimationTimingFunction.Linear,
                                iterationCount = AnimationIterationCount.Infinite,
                            ),
                        ),
                ) {
                    val row1Items = Testimonial.entries.take(3)
                    repeat(4) { // Sufficient repeats for smooth loop
                        row1Items.forEach { testimonial ->
                            TestimonialCardV2(
                                modifier = Modifier.margin(leftRight = 15.px),
                                testimonial = testimonial,
                                breakpoint = breakpoint,
                            )
                        }
                    }
                }
            }

            // Row 2: Scrolling Right
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(topBottom = 20.px),
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .animation(
                            TestimonialMarqueeRight.toAnimation(
                                duration = 100.s,
                                timingFunction = AnimationTimingFunction.Linear,
                                iterationCount = AnimationIterationCount.Infinite,
                            ),
                        ),
                ) {
                    val row2Items = Testimonial.entries.drop(3)
                    repeat(4) {
                        row2Items.forEach { testimonial ->
                            TestimonialCardV2(
                                modifier = Modifier.margin(leftRight = 15.px),
                                testimonial = testimonial,
                                breakpoint = breakpoint,
                            )
                        }
                    }
                }
            }
        }
    }
}
